import React, { useContext } from 'react'
import { Button, ButtonType } from 'syngenta-digital-cropwise-react-ui-kit';
import { RootContext } from '../../RootProvider'
import { useTranslation } from 'react-i18next'

const FourZeroFourView = ({ relogin }: { relogin?: boolean }) => {
  const { auth } = useContext(RootContext)
  const { t } = useTranslation()

  return (
    <div className="h-screen flex flex-col justify-center items-center">
      <p>{t('resource-mapper.404')}</p>
      {relogin &&
        <Button
          data-cy='logout_button'
          type={ButtonType.primary}
          size='large'
          onClick={auth.logout}>
          {t('Integration.cropwise_login')}
        </Button>
      }
    </div>
  )
}

export default FourZeroFourView